import PieChartElement from '../../../Common/PieChartElement';
import SearchableDropdown from '../../../Common/SearchDropdown';


export default function PieChartSwitcher({ chartData, chartList, type, onSelectHandler }) {
    const chartType = String(type)?.toUpperCase();
    return (
        <div className="mt-4 bg-white p-3 rounded shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0 text-capitalize">Inventory Pie Chart</h5>
                {chartList ? <SearchableDropdown
                    placeholder={`${chartType} Type`}
                    value={type}
                    error={false}
                    options={chartList ?? []}
                    onSelect={onSelectHandler}
                /> : null}
            </div>
            <PieChartElement chartData={chartData} />
        </div>
    );
}